import { createSelector } from 'reselect';
import { pendingResponse } from '../../fetchStatus';

const accountSelector = state => state?.account;

export const ordersResponseSelector = createSelector([accountSelector], account => account?.orders ?? pendingResponse);
export const ordersSelector = createSelector([ordersResponseSelector], ordersResponse => ordersResponse?.data);
